import { useNavigate } from "react-router-dom";
import RTableLayout from "../../../../../responsive/layout/RTableLayout";
import {
    CMargin,
    DText,
    Flex,
    Row,
} from "../../../../../../styles/CommonStyles";
import Operation from "../../../../../common/utils/Operation";
import { TradeTypeBadge } from "../../../../../../styles/main/orders";
import { formatNumber } from "../../../../../../core/utils/common";
import DateTime from "../../../../../common/utils/DateTime";
import { RespIndex } from "../../../../../../styles/main/MainCommonStyles";

const RUserCardHistoryTable = ({ data }) => {

    const { data: transactions } = data;
    const navigate = useNavigate();

    return (
        <RTableLayout data={data}>
            {transactions?.data?.map((transaction, idx) => {

                const merchant =
                    transaction.merchantName ||
                    transaction.detail ||
                    "-";

                return (
                    <Row
                        key={transaction.id}
                        index={idx}
                        cs="100%"
                    >

                        {/* Header */}

                        <Flex fw justify="space-between">

                            <DText
                                main
                                fontSize="s"
                                style={{
                                    wordBreak: "break-all",
                                }}
                            >
                                {transaction.transactionDisplayId}
                            </DText>

                        </Flex>

                        <CMargin margin="10px" />

                        {/* Merchant */}

                        <DText
                            main
                            fontSize="s"
                            style={{
                                wordBreak: "break-word",
                            }}
                        >
                            {merchant}
                        </DText>

                        <CMargin margin="10px" />

                        {/* Type */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Type
                            </DText>

                            <TradeTypeBadge color="primary">
                                {transaction.type}
                            </TradeTypeBadge>

                        </Flex>

                        {/* Amount */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Amount
                            </DText>

                            <DText main fontSize="s">
                                {formatNumber(transaction.amount)}{" "}
                                {transaction.transactionCurrency}
                            </DText>

                        </Flex>

                        {/* Fee */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Fee
                            </DText>

                            <DText main fontSize="s">
                                {formatNumber(transaction.fee)}{" "}
                                {transaction.currency}
                            </DText>

                        </Flex>

                        {/* Direction */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Direction
                            </DText>

                            <DText main fontSize="s">
                                {transaction.direction}
                            </DText>

                        </Flex>

                        {/* Status */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Status
                            </DText>

                            <TradeTypeBadge
                                color={
                                    transaction.status === "CLOSED"
                                        ? "success"
                                        : transaction.status === "PENDING"
                                            ? "warning"
                                            : "danger"
                                }
                            >
                                {transaction.status}
                            </TradeTypeBadge>

                        </Flex>

                        {/* Date */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Date
                            </DText>

                            <DateTime
                                dt={Number(transaction.transactionTime)}
                            />

                        </Flex>

                        <RespIndex>
                            {idx + 1}
                        </RespIndex>

                    </Row>
                );
            })}
        </RTableLayout>
    );
};

export default RUserCardHistoryTable;